import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Header, Icon, Radio} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/groupBy';
import 'rxjs/add/operator/do';
import {Tooltip} from 'react-tippy';
import isEqual from 'lodash/isEqual';
import {NavigationAssignmentToolTip} from "components/break/tooltips/breaks-nav-site-filter-tool-tips";
import FieldStatusIcon from "../FieldStatusIcon";

class BreakCategoriesEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.makeState(props);
    }

    componentWillReceiveProps(props, context) {
        const nextState = this.makeState(props);

        if (!isEqual(this.state, nextState)) {
            this.setState(nextState, () => {
                this.props.onValueChanged(this.state.selectedCategories, this.props.currentPlatform);
            });
        }
    }

    makeState(props) {
        let providedCategories = props.defaultValue || [];

        return {
            selectedCategories: providedCategories
        };
    }

    containsCategory(category) {
        return this.state.selectedCategories.indexOf(category) > -1;
    }

    primaryCategoryOfSub(subcategory) {
        for (let primaryCategory of this.props.categories) {
            if (primaryCategory.subcategories.indexOf(subcategory) > -1) {
                return primaryCategory;
            }
        }
        return null;
    }

    toggleCategory(category) {
        let selectedPrimary = this.primaryCategoryOfSub(category);
        let newCategories = [selectedPrimary.category, category];

        this.setState({
            selectedCategories: newCategories
        });

        this.props.onValueChanged(newCategories, 'categories', null);
    }

    render() {
        let isSaving = this.props.isSaving;
        let error = this.props.error;
        let savedField = this.props.savedField;
        return (
            <section >
                <Header as='h5' className="header-text-brown">Select navigation and filtering options</Header>
                <p className="header-subtext navigation-header"><i className="asterisk icon inline"/>Navigation assignment
                  <Tooltip
                    // options
                    html={(
                        <div style={{'maxWidth': '600px', 'maxHeight': '600px', 'overflow': 'auto'}}>
                          <h4>Navigation assignment</h4>
                          <NavigationAssignmentToolTip/>
                        </div>
                    )}
                    arrow="true"
                    position="right-top"
                    theme="light"
                    trigger="click"
                    style={{width: '40%'}}
                    className="db-tooltip">
                      <FieldStatusIcon error={error} saved={savedField} isSaving={isSaving} show={true}/>
                    <Icon color="blue" name="info circle"/>
                </Tooltip></p>
                {this.props.currentPlatform === "MASTER" || this.props.currentPlatform === "DAILYBREAK" ? this.props.categories.map((category) => (
                    <section key={category.category} className="db-break-category-section">
                        <h4><FormattedMessage id={`editbreak.breaksNavFilters.${category.category}`}/></h4>
                        <section>
                            {category.subcategories.map((subcategory, index) => (
                              <Fragment>
                                <Radio name={this.props.name}
                                          key={subcategory}
                                          value={subcategory}
                                          className="db-nav-filter-radio"
                                          checked={this.containsCategory(subcategory)}
                                          onChange={(event, data) => this.toggleCategory(data.value)}
                                          label={{children: <FormattedMessage id={`editbreak.breaksNavFilters.${subcategory}`}/>}}/>
                                  {Math.abs(index % 2) === 1 && index !== 0 ? <br/> : ""}
                                </Fragment>
                            ))}
                        </section>
                    </section>
                )) : (
                    <p>Can only edit categories on MASTER or DAILYBREAK platform.</p>
                )}
            </section>
        );
    }
}

BreakCategoriesEditor.propTypes = {
    onValueChanged: PropTypes.func.isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({
        category: PropTypes.string.isRequired,
        subcategories: PropTypes.arrayOf(PropTypes.string).isRequired
    })),
    value: PropTypes.shape({
        MASTER: PropTypes.any,
        DAILYBREAK: PropTypes.any,
        EMBED: PropTypes.any,
        DEMO: PropTypes.any,
    }).isRequired,
};

BreakCategoriesEditor.defaultProps = {
    categories: []
};

export default BreakCategoriesEditor;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/BreakCategoriesEditor.jsx